import { useEffect, useState } from "react";
import { Button } from "primereact/button";

import { Divider } from "primereact/divider";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";

import Loading from "../common/Loading";
import NoContent from "../common/NoContent";
import PageTitle from "../common/PageTitle";
import TabHeader from "../common/TabHeader";
import { useAppContext } from "../../providers/ProviderAppContainer";
import { TEXT_NORMAL } from "../../style";
import FieldNote from "./common/FieldNote";

export default function WebsiteMobileBar() {
    const { requestAPI, showToast } = useAppContext();
    const [loading, setLoading] = useState();
    const [saving, setSaving] = useState();
    const [error, setError] = useState();
    const [record, setRecord] = useState();

    useEffect(() => {
        requestAPI({
            requestPath: "website/mobile-bar",
            requestMethod: "GET",
            setLoading,
            onRequestStart: setError,
            onRequestFailure: setError,
            onResponseReceieved: (data, responseCode) => {
                if (data && responseCode === 200) setRecord(data);
                else setError("Couldn't load Mobile Bar");
            },
        });
    }, [requestAPI]);

    const saveRecord = () => {
        requestAPI({
            requestPath: "website/mobile-bar",
            requestMethod: "PATCH",
            requestPostBody: record,
            setLoading: setSaving,
            onRequestFailure: () => showToast({ severity: "error", summary: "Failed", detail: "Failed To Update Mobile Bar !", life: 2000 }),
            onResponseReceieved: (updated, responseCode) => {
                if (updated && responseCode === 200) {
                    setRecord(updated);
                    showToast({ severity: "success", summary: "Updated", detail: "Mobile Bar Updated", life: 1000 });
                } else {
                    showToast({ severity: "error", summary: "Failed", detail: updated?.error || "Failed To Update Mobile Bar !", life: 2000 });
                }
            },
        });
    };

    return (
        <div className="flex flex-column h-full">
            <PageTitle title="Mobile Bar" />
            <TabHeader
                className="px-3 pt-3"
                title="Phone bar"
                highlights={["The bar fixed to the bottom of the screen on a phone", "Leave WhatsApp or phone blank to use the site phone and WhatsApp link"]}
            />
            <Divider />
            {loading ? <Loading /> : null}
            {error ? <NoContent error={error} /> : null}
            {!loading && !error && record ? (
                <div className="flex-1 overflow-y-scroll p-3 flex flex-column">
                    <div>
                        <FloatLabel className="mt-5">
                            <InputText id="mobile_whatsapp" className="w-full" value={record?.mobile_whatsapp ?? ""} onChange={(event) => setRecord((prev) => ({ ...prev, mobile_whatsapp: event.target.value }))} disabled={saving} pt={{ root: { className: TEXT_NORMAL } }} />
                            <label htmlFor="mobile_whatsapp">WhatsApp link</label>
                        </FloatLabel>
                        <FieldNote text="The WhatsApp button. Use a full link starting with https://. Leave blank to use the site WhatsApp link." />
                    </div>
                    <div>
                        <FloatLabel className="mt-5">
                            <InputText id="mobile_phone" className="w-full" value={record?.mobile_phone ?? ""} onChange={(event) => setRecord((prev) => ({ ...prev, mobile_phone: event.target.value }))} disabled={saving} pt={{ root: { className: TEXT_NORMAL } }} />
                            <label htmlFor="mobile_phone">Phone</label>
                        </FloatLabel>
                        <FieldNote text="Required if the site phone is empty. The Call button. Leave blank to use the site phone." />
                    </div>
                    <div>
                        <FloatLabel className="mt-5">
                            <InputText id="mobile_courses_url" className="w-full" value={record?.mobile_courses_url ?? ""} onChange={(event) => setRecord((prev) => ({ ...prev, mobile_courses_url: event.target.value }))} disabled={saving} pt={{ root: { className: TEXT_NORMAL } }} />
                            <label htmlFor="mobile_courses_url">Courses button link</label>
                        </FloatLabel>
                        <FieldNote text="Example: /courses." />
                    </div>
                    <div>
                        <FloatLabel className="mt-5">
                            <InputText id="mobile_app_url" className="w-full" value={record?.mobile_app_url ?? ""} onChange={(event) => setRecord((prev) => ({ ...prev, mobile_app_url: event.target.value }))} disabled={saving} pt={{ root: { className: TEXT_NORMAL } }} />
                            <label htmlFor="mobile_app_url">App button link</label>
                        </FloatLabel>
                        <FieldNote text="Example: /#app." />
                    </div>
                    <Button className="mt-5 align-self-start" label="Save" icon="pi pi-check" loading={saving} onClick={saveRecord} />
                </div>
            ) : null}
        </div>
    );
}
